import React, { useEffect } from 'react';

import { appFormUtil } from 'modules/common';
import {
  SaveFolderInput,
  useSaveFolderFormQuery,
  useSaveFolderMutation
} from 'generated/graphql';

import _ from 'lodash';

export type IFormState = {
  id: string;
  name: string;
  parentFolderId: string;
  projectId: string;
};

const initialState = {
  id: '',
  name: '',
  parentFolderId: '',
  projectId: ''
};

export function useFormState(id: string, projectId: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      id: {
        label: 'Id',
        type: 'text'
      },
      name: {
        label: 'Folder name',
        type: 'text'
      },
      parentFolderId: {
        label: 'Parent folder id',
        type: 'text'
      },
      projectId: {
        label: 'Project id',
        type: 'text'
      }
    }
  });

  useEffect(() => {
    if (projectId !== '' && formState.projectId === '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'projectId',
          value: projectId
        }
      });
    }
  }, [
    dispatch,
    formState.projectId,
    projectId
  ]);

  const { data, loading, called } = useQuery(id);

  useEffect(() => {
    if (!_.isNil(data.id) && !loading && called && formState.id === '') {
      dispatch({
        type: 'BATCH_UPDATE',
        payload: {
          ...formState,
          ...data
        }
      });
    }

  }, [
    called,
    data,
    dispatch,
    formState,
    loading
  ]);


  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}


export interface IData extends Omit<IFormState, 'projectId'> {}

export function useQuery(id: string) {
  const tuple = useSaveFolderFormQuery({
    variables: {
      id
    },
    skip: id === ''
  });

  return React.useMemo(
    () => {
      const data: IData = {
        id: tuple.data?.folder?.id ?? '',
        name: tuple.data?.folder?.name ?? '',
        parentFolderId: tuple.data?.folder?.parent?.id ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}

export function useSaveFolder() {
  const [
    fnMutate,
    tuple
  ] = useSaveFolderMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: SaveFolderInput) => {
      await fnMutate({
        variables: {
          input
        }
        // updateQueries: {
        //   ...gqlCacheUtil.genUpdateQueryMap<FolderListSectionQuery, SaveFolderMutation>(FolderListSectionDocument, (prevState, { mutationResult }) => {
        //     if (!prevState.project?.id) {
        //       return prevState;
        //     }
        //     const existingFolders = prevState.project?.folders ?? [];

        //     const existingFolder = existingFolders.find((node) => node.id === mutationResult.data?.saveFolder?.id);
        //     if (existingFolder) {

        //       return {
        //         ...prevState,
        //         project: {
        //           ...prevState.project,
        //           folders: _.compact([
        //             ...existingFolders.map((node) => {
        //               if (node.id === mutationResult.data?.saveFolder?.id) {
        //                 return {
        //                   ...node,
        //                   ...mutationResult.data.saveFolder
        //                 };
        //               } else {
        //                 return node;
        //               }
        //             })
        //           ])
        //         }
        //       };
        //     } else {
        //       return {
        //         ...prevState,
        //         project: {
        //           ...prevState.project,
        //           folders: _.compact([
        //             ...existingFolders,
        //             mutationResult.data?.saveFolder
        //           ])
        //         }
        //       };
        //     }
        //   })
        // }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
